import { useEffect} from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import { Sidebar } from "./components/sidebar/sidebar";
import { ScoutingPage } from "./pages/Scouting";
import { ScoutingReport } from "./pages/ScoutingReport";
import { Guts } from "./pages/guts/Guts";
import Data from "./pages/Data";
import Charting from "./pages/Charting";
import { Recruiting } from "./pages/Recruiting";
import SignIn from "./pages/SignIn";
import { HomePage } from "./pages/HomePage";
import { Toaster } from "react-hot-toast";
import { PlayerPage } from "./pages/player-page";
import { TeamPage } from "./pages/team-page";
import { ScoutingReportReport } from "./pages/reports/scouting-report/ScoutingReport";
import { LongballPlayerReportRender } from "./pages/reports/longball-player-report-render";
import { LongballTeamReportRender } from "./pages/reports/longball-team-report-render";
import { Leaderboards } from "./pages/leaderboards";
import { GamePage } from "./pages/game-page";
import { Scoreboard } from "./pages/Scoreboard";
import { PlayerListsPage } from "./pages/player-lists";
import { SprayChartsPage } from "./pages/spray-chart-page";
import { BaserunningReportPage } from "./pages/baserunning-report-page";
import { BaserunningReportRender } from "./pages/reports/baserunning-report";
import { PlayersToWatchPage } from "./pages/players-to-watch-page";
import { PlayersToWatchRender } from "./pages/reports/players-to-watch-render";
import { SprayChartReport } from "./pages/reports/spray-chart-render";
import { DepthChartPage } from "./pages/depth-chart-page";
import { DepthChartRender } from "./pages/reports/depth-chart-render";
import { HittingSplitsReportPage, PitchingSplitsReportPage } from "./pages/splits-report-page";
import { SplitsReportRender } from "./pages/reports/splits-report";
import ApiKeys from "./pages/ApiKeys";
import { LongBallPage } from "./pages/longball";
import AuthManager from "./managers/AuthManager";

const MainLayout = ({ children }) => (
  <div className="App flex h-screen">
    <Sidebar />
    <div className="content flex-grow overflow-auto">
      {children}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: "#333",
            color: "#fff",
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: "#4ade80",
              secondary: "#fff",
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: "#ef4444",
              secondary: "#fff",
            },
          },
        }}
      />
    </div>
  </div>
);

const AppRoutes = () => {
  const location = useLocation();
  const isRenderRoute = location.pathname.startsWith('/render/');

  if (isRenderRoute) {
    switch (location.pathname.split('/')[2]) {
      case "scouting-report":
        return (
          <Routes>
            <Route path="/render/scouting-report" element={<ScoutingReportReport />} />
          </Routes>
        );
      case "baserunning-report":
        return (
          <Routes>
            <Route path="/render/baserunning-report" element={<BaserunningReportRender />} />
          </Routes>
        );
      case "players-to-watch":
        return (
          <Routes>
            <Route path="/render/players-to-watch" element={<PlayersToWatchRender />} />
          </Routes>
        );
      case "spray-chart":
        return (
          <Routes>
            <Route path="/render/spray-chart" element={<SprayChartReport />} />
          </Routes>
        );
      case "depth-chart":
        return (
          <Routes>
            <Route path="/render/depth-chart" element={<DepthChartRender />} />
          </Routes>
        );
      case "splits-report":
        return (
          <Routes>
            <Route path="/render/splits-report" element={<SplitsReportRender />} />
          </Routes>
        );
      case "longball-player-report":
        return (
          <Routes>
            <Route path="/render/longball-player-report" element={<LongballPlayerReportRender />} />
          </Routes>
        );
      case "longball-team-report":
        return (
          <Routes>
            <Route path="/render/longball-team-report" element={<LongballTeamReportRender />} />
          </Routes>
        );
      default:
        return null;
    }
  }

  return (
    <MainLayout>
      <Routes>
        <Route path="/signin" element={<SignIn />} />
        <Route path="/" element={<HomePage />} />  
        <Route path="/guts" element={<Guts />} />
        <Route path="/scouting" element={<ScoutingPage />} />
        <Route path="/scouting/:reportId/:slug" element={<ScoutingReport />} />
        <Route path="/recruiting" element={<Recruiting />} />
        <Route path="/charting" element={<Charting />} />
        <Route path="/data" element={<Data />} />
        <Route path="/player/:playerId" element={<PlayerPage />} />
        <Route path="/team/:teamId" element={<TeamPage />} />
        <Route path="scouting/reports/:reportId/spraycharts" element={<SprayChartsPage />} />
        <Route path="scouting/reports/:reportId/baserunning" element={<BaserunningReportPage />} />
        <Route path="scouting/reports/:reportId/players-to-watch" element={<PlayersToWatchPage />} />
        <Route path="scouting/reports/:reportId/depth-chart" element={<DepthChartPage />} />
        <Route path="/scouting/reports/:reportId/hitting-splits" element={<HittingSplitsReportPage />} />
        <Route path="/scouting/reports/:reportId/pitching-splits" element={<PitchingSplitsReportPage />} />
        <Route path="/leaderboards" element={<Leaderboards />} />
        <Route path="/scoreboard" element={<Scoreboard />} />
        <Route path="/games/:year/:gameId" element={<GamePage />} />
        <Route path="/player-lists" element={<PlayerListsPage />} />
        <Route path="/api-keys" element={<ApiKeys />} />
        <Route path="/longball" element={<LongBallPage />} />
      </Routes>
    </MainLayout>
  );
};

function App() {
  useEffect(() => {
    AuthManager.ensureUser("api");
  }, []);

  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
